import { useEffect, useMemo, useState } from "react";
import produce from "immer";
import { isBoolean } from "lodash";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { SearchFragmentUsers, SortInfluencer } from "@radarly/models/search";
import { useAuthorWidgetData } from "./useAuthorWidgetData";

export function useTopAuthorsWidget(
  project: number,
  fragment: SearchFragmentUsers,
  readonly: boolean = false,
  mutualized: boolean = true
) {
  const [sort, setSort] = useState<SortInfluencer>(
    fragment.request.aggs.users.sort.on
  );
  useEffect(() => {
    setSort(fragment.request.aggs.users.sort.on);
  }, [fragment.request.aggs.users.sort.on]);
  const formatedFragment = useMemo(() => {
    return produce(fragment, (draft) => {
      draft.request.aggs.users.sort.on = sort;
    });
  }, [fragment, sort]);
  const { data, loading, isEmpty } = useAuthorWidgetData(
    project,
    formatedFragment,
    mutualized
  );
  const locale = useCurrentUserLocale();
  return {
    data,
    loading,
    sort,
    setSort: isBoolean(readonly) && readonly ? undefined : setSort,
    isEmpty,
    locale,
  };
}
